import { SupportedChainId } from '../connectors/index'

type AddressMap = { [chainId: number]: string }

export const SHARKDOODOO_ADDRESS: AddressMap = {
    [SupportedChainId.MAINNET]: '0xE3FeB315Ae49491900e34763d7d5aEcc4277D843',
    [SupportedChainId.HARDHAT]: '0x5FbDB2315678afecb367f032d93F642f64180aa3',
    [SupportedChainId.RINKEBY]: '0x447ef5CD74Cbdb1a2835d84AbD6e99020E420732',


}
